export const addTowishlistApi = async ({ product_id,  sku_code, customer_id }) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/add-wishlist/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_id,
       
        sku_code,
        customer_id,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add product to cart");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};


export const fetchwishlist = async (customer_id) => {
  try {
    // Append customer_id as a query parameter
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/add-wishlist/?customer_id=${customer_id}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};

export const removewislist = async (customer_id, sku_code) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/add-wishlist/?customer_id=${customer_id}&sku_code=${sku_code}`,
      {
        method: "DELETE",
      }
    );

    if (!response.ok) {
      throw new Error("Failed to remove item from cart");
    }

    return await response.json();
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};